import { plural } from '@cian/utils';

import { IPhone } from '../types/offer';

export function getFormattedPhoneNumber(phone: IPhone): string {
  if (!phone || !phone.number) {
    return '';
  }

  return `${phone.countryCode && phone.countryCode.startsWith('+') ? '' : '+'}${phone.countryCode} ` +
      `${phone.number.substr(0, 3)} ` +
      `${phone.number.substr(3, 3)}-${phone.number.substr(6, 2)}-${phone.number.substr(8, 2)}`;
}

export function validateEmailFormat(email: string): boolean {
  return /.+@.+\..+/gi.test(email);
}

export function formatBedRoomsLabel(count: number) {
  if (count === 0) {
    return 'Спален';
  }

  return `${count} ${plural(count, ['спальня', 'спальни', 'спален'])}`;
}

export function phoneToChatFromat(phone?: string) {
  return (phone && !phone.startsWith('+')) ? `+${phone}` : phone;
}

export function parseHtmlEntities(str: string) {
  return str.replace(new RegExp('&#([0-9]{1,3});', 'g'), (match, numStr) => {
      return String.fromCharCode(parseInt(numStr, 10));
  });
}
